import { useSelector } from "react-redux";
import { useAppDispatch } from "hooks/hooks";
import Modal from "components/Modal/Modal";
import { toast } from "react-toastify";

import {
  deleteProject,
  selectProjectForDeletion,
  selectState,
  setDeleteProjectModalOpen,
} from "../main.slice";

const DeleteProjectModal = () => {
  const { deleteProjectModalOpen } = useSelector(selectState);
  const project = useSelector(selectProjectForDeletion);
  const dispatch = useAppDispatch();

  const close = () => {
    dispatch(setDeleteProjectModalOpen({ visible: false, index: -1 }));
  };

  const doDelete = async () => {
    try {
      await dispatch(deleteProject(project.projectId));
      toast.success("Uspesno obrisan.");
      close();
    } catch (err) {
      console.log(err);
    }
  };

  return (
    <Modal
      isOpen={deleteProjectModalOpen}
      onClick={doDelete}
      onClose={close}
      title="Brisanje projekta"
    >
      <p className="info-msg">
        Da li ste sigurni da želite da obrišete sledeći projekat:
        <br />
        <br />
        <b>{project?.projectName} ?</b>
      </p>
    </Modal>
  );
};

export default DeleteProjectModal;
